import { createFeature, createReducer, on } from '@ngrx/store'
import * as scActions from './employee-salary.actions'
import { createInitialSalaryDraft, initialState } from './employee-salary.state'

export const employeeSalaryReducer = createReducer(
  initialState,

  //Load All Salaries
  on(scActions.loadAllSalariesSuccess, (state, { salaries }) => ({
    ...state,
    allSalaries: salaries,
    loading: false
  })),

  on(scActions.loadAllSalariesFailure, ({ error }) => ({
    ...initialState,
    error
  })),

  //Load latest Salary
  on(scActions.loadSalary, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(scActions.loadSalarySuccess, (state, { salary }) => ({
    ...state,
    employeeSalary: { ...salary },
    loading: false
  })),

  on(scActions.loadSalaryFailure, ({ error }) => ({
    ...initialState,
    error
  })),

  // Add parts of salary
  //Add statutory Compliances
  on(scActions.addBusinessRequirements, (state, { businessRequirements }) => ({
    ...state,
    employeeSalary: {
      ...state.employeeSalary,
      ...businessRequirements
    },
    loading: false
  })),
  //Add statutory Compliances
  on(scActions.addStatutoryCompliances, (state, { statutoryCompliances }) => ({
    ...state,
    employeeSalary: {
      ...state.employeeSalary,
      statutoryCompliances
    },
    loading: false
  })),
  //Add ctc value
  on(scActions.addCtcValue, (state, { ctcValue }) => ({
    ...state,
    employeeSalary: {
      ...state.employeeSalary,
      ctcValue
    },
    loading: false
  })),
  //Add ctc
  on(scActions.addCtc, (state, { ctc }) => ({
    ...state,
    employeeSalary: {
      ...state.employeeSalary,
      ctc,
      effectiveFrom: ctc.effectiveFrom,
      payoutFrom: ctc.payoutFrom
    },
    loading: false
  })),
  //Add Salary Data
  on(scActions.addSalaryData, (state, { salaryData }) => ({
    ...state,
    employeeSalary: {
      ...state.employeeSalary,
      salaryData
    },
    loading: false
  })),

  //Add Complete Salary
  on(scActions.addSalarySuccess, (state, { salary }) => ({
    ...state,
    employeeSalary: { ...salary },
    loading: false
  })),

  on(scActions.addSalaryFailure, (state, { error }) => ({
    ...state,
    error
  })),

  //Edit
  on(scActions.editSalarySuccess, (state, { salary }) => ({
    ...state,
    employeeSalary: { ...salary },
    loading: false
  })),

  on(scActions.editSalaryFailure, (state, { error }) => ({
    ...state,
    error
  })),

  //Delete
  on(scActions.deleteSalarySuccess, state => ({
    ...state,
    employeeSalary: initialState.employeeSalary,
    loading: false
  })),

  on(scActions.deleteSalaryFailure, (state, { error }) => ({
    ...state,
    error
  })),

  //Clear State
  on(scActions.clearSalaryState, () => initialState),

  // --- Revision Workflow Reducers ---
  // Update Revised Business Requirements
  on(
    scActions.salaryRevisionActions.initiateSalaryRevision,
    (state, { belongsTo, employeeId }) => ({
      ...state,
      revisedSalary: {
        ...state.employeeSalary,
        belongsTo,
        employeeId
      }
    })
  ),
  // Update Revised Statutory Compliances
  on(
    scActions.salaryRevisionActions.updateStatutoryCompliances,
    (state, { statutoryCompliances }) => ({
      ...state,
      revisedSalary: {
        ...state.revisedSalary,
        statutoryCompliances
      }
    })
  ),
  //Update Revised ctc value
  on(scActions.salaryRevisionActions.updateCTCValue, (state, { ctcValue }) => ({
    ...state,
    revisedSalary: {
      ...state.revisedSalary,
      ctcValue
    }
  })),
  //Update Revised ctc
  on(scActions.salaryRevisionActions.updateCTC, (state, { ctc }) => ({
    ...state,
    revisedSalary: {
      ...state.revisedSalary,
      ctc,
      effectiveFrom: ctc.effectiveFrom,
      payoutFrom: ctc.payoutFrom
    }
  })),
  //Update Revised Salary Data
  on(scActions.salaryRevisionActions.updateSalaryData, (state, { salaryData }) => ({
    ...state,
    revisedSalary: {
      ...state.revisedSalary,
      salaryData
    }
  })),
  //Save Revised Salary
  on(scActions.salaryRevisionActions.saveRevisedSalarySuccess, (state, { salary }) => ({
    ...state,
    employeeSalary: { ...salary },
    revisedSalary: createInitialSalaryDraft()
  }))

  //Load Salaries by BusinessId
  //on(loadAllSalariesByBusinessId.loadSalariesSuccess, (state, { salaries }) => ({
  //  ...state,
  //  allSalariesByBusiness: salaries,
  //  loading: false
  //})),

  //on(loadAllSalariesByBusinessId.loadSalariesFailure, (state, { error }) => ({
  //  ...state,
  //  error
  //}))
)

export const employeeSalaryFeature = createFeature({
  name: 'employeeSalary',
  reducer: employeeSalaryReducer
})

export const {
  name,
  reducer,
  selectEmployeeSalary,
  selectRevisedSalary,
  selectAllSalaries,
  selectAllSalariesByBusiness,
  selectLoading,
  selectError,
  selectEmployeeSalaryState
} = employeeSalaryFeature
